"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsFileUri = void 0;
const class_validator_1 = require("class-validator");
function IsFileUri(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: 'isFileUri',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [propertyName],
            options: {
                message: 'must be s3-key:, data: ot http: url',
                ...validationOptions,
            },
            validator: {
                validate(value, args) {
                    return ((0, class_validator_1.isURL)(value, {
                        protocols: ['s3-key'],
                        require_protocol: true,
                        require_valid_protocol: true,
                        require_host: false,
                        require_tld: false,
                    }) ||
                        (0, class_validator_1.isDataURI)(value) ||
                        (0, class_validator_1.isURL)(value, {
                            protocols: ['http', 'https'],
                            require_protocol: true,
                            require_valid_protocol: true,
                        }));
                },
            },
        });
    };
}
exports.IsFileUri = IsFileUri;
//# sourceMappingURL=is-file-uri.js.map